import React, { Suspense, useEffect, useState } from "react";
import {  Box, Button, CircularProgress, Divider, Typography,  useTheme  } from "@mui/material";
 
import BuscarCliente from "./buscarCliente";
import AlertModal from "../../../components/utilities/AlertModal";
 
const Cliente = React.lazy(() => import('../../../components/agent/cliente/Cliente'));
const HistoricoGestiones = React.lazy(() => import('../../../components/agent/historico/HistoricoGestiones'));
const Cuentas = React.lazy(() => import('../../../components/agent/cuenta/CuentasVentas'));
const MemoizedCuentas = React.memo(Cuentas);

const AdminGestionVenta = () => {
  const theme = useTheme();
  const [campaignDiscadorExists, setCampaignDiscadorExists] = useState(false);
  const [LineaNegocio, setLineaNegocio] = useState(null);
  const [reloadHistorico, setReloadHistorico] = useState(false);
  const [searchFlag, setSearchFlag] = useState(false);

  const [formulario, setFormulario] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const handleCloseModalAlert = () => {    setModalOpen(false); };
  const uniqueid = -3;
  const idCartera = 1
  let userString = localStorage.getItem("user");
  let user = JSON.parse(userString);
  const phone_number = '999999999'
  const [idCliente, setIdCliente] = useState(null);
  const [vendorId, setVendorId] = useState(null);
  const [campaign, setCampaign] = useState(null);
  const [isBuscarClienteVisible, setIsBuscarClienteVisible] = useState(true);
  const handleHistorico = (shouldReload) => {
    if (shouldReload) {
      setReloadHistorico(prev => !prev);  // Cambia el estado para forzar la recarga
      setIsBuscarClienteVisible(true);
      setVendorId(null)
        setCampaignDiscadorExists(false);  
    }
  };
  
  const manejarIdCliente = (idCliente) => {
    setIdCliente(idCliente);
  };
  const handleSelectClient = (client) => {
    setVendorId(client.identificador);
    setIsBuscarClienteVisible(false);
    setSearchFlag(prev => !prev);
  }
  const handleLinea = (linea) => {
    setLineaNegocio(linea);
    setFormulario(linea.formulario);
    setCampaign(linea.linea_negocio)

  }
  const handleOpenBuscarCliente = () => {
    setIsBuscarClienteVisible(true);
  };
   
    useEffect(() => {
      if (vendorId) {
              setCampaignDiscadorExists(true);  
      }
    }, [vendorId]);
    return (
      <Box sx={{ flexGrow: 1, padding: 2, mx: [1, 2, 3], bgcolor: theme.palette.background.default }}>
        {isBuscarClienteVisible &&  
        <BuscarCliente
          idCartera={idCartera}
          onSelectClient={handleSelectClient}
          onLineaChange={handleLinea}
    
        />}
          <Box my={1}>  {/* Este Box agregará márgenes arriba y abajo */}
                    <Divider sx={{ padding: '2' }} />
                </Box>
        {!isBuscarClienteVisible && 
                <Button variant="contained" color="primary" onClick={handleOpenBuscarCliente}>
                    Buscar Cliente de nuevo
                </Button>
            }
        {campaignDiscadorExists  && LineaNegocio ? (
          <>
            <Suspense fallback={<CircularProgress />}>
              <Cliente identificador={vendorId} lineaNegocio={LineaNegocio} manejarIdCliente={manejarIdCliente}  campania={campaign}/>
            </Suspense>
            {idCliente && (
            <>
            <Suspense fallback={<CircularProgress />}>
                    <MemoizedCuentas
                    identificador={vendorId}
                    id_linea_negocio={LineaNegocio.id}
                    id_cartera={idCartera}
                    codigo_llamada={uniqueid}
                    codigo_usuario={user.username}
                    numero_contactado={phone_number}
                    campaign={campaign}
                    idCliente={idCliente}
                    formulario={formulario}
                    callBackHistorico={handleHistorico}
                    searchFlag={searchFlag}
                    />
                </Suspense>

                <Box my={1}>  {/* Este Box agregará márgenes arriba y abajo */}
                    <Divider sx={{ padding: '2' }} />
                </Box>

                <Suspense fallback={<CircularProgress />}>
                    <Box mb={2}>
                        <HistoricoGestiones id_cliente={idCliente} reload={reloadHistorico} codigo_usuario={user.username}/>
                    </Box>
                </Suspense>
            </>
            )}
          </>
        ) : (
          <AlertModal
          open={modalOpen}
          onClose={handleCloseModalAlert}
          alertType={'error'}
          message={`No se encontró la campaña ${campaign}`}
        />
        )}
      </Box>
    );
  };
  
  export default AdminGestionVenta;